<template>
  <div class="is-flex is-align-items-center">
    <img
      @click="toggle()"
      :src="getSelectedImage()"
      class="is_hot operation_icon"
    />
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { bus } from '@/custom/classes/bus.js'

export const FLAME_ACTIVE_ONLY_MSG = 'אפשר להדליק להבה רק למשרה פעילה'
export default {
  name: 'is-hot',
  props: ['payload'],
  data () {
    return {
      is_hot: this.payload.is_hot,
      // live status: payload.status is a snapshot from when the window opened
      status: this.payload.status
    }
  },
  created () {
    // Status.vue announces when the server cleared the flame on a status change.
    bus.$on('position_flame_cleared', this.onFlameCleared)
    // Status.vue / CreatePositionStepThree announce a successful status change.
    bus.$on('position_status_changed', this.onStatusChanged)
  },
  beforeDestroy () {
    bus.$off('position_flame_cleared', this.onFlameCleared)
    bus.$off('position_status_changed', this.onStatusChanged)
  },
  watch: {
    'payload.status' (status) {
      this.status = status
    }
  },
  methods: {
    onFlameCleared (position_id) {
      if (position_id === this.payload.id) this.is_hot = false
    },
    onStatusChanged ({ position_id, status } = {}) {
      if (position_id != null && String(position_id) === String(this.payload.id)) this.status = status
    },
    toast (text) {
      this.$utils.emit('show_toast', { text })
    },
    errorMessage (error) {
      const data = error && error.response && error.response.data
      let msg = null
      if (data) {
        const e = data.errors || data.error || data.message
        if (e && e.is_hot) msg = e.is_hot
        else msg = e
        if (Array.isArray(msg)) msg = msg.join(', ')
        if (msg && typeof msg === 'object') msg = null
      }
      return msg || FLAME_ACTIVE_ONLY_MSG
    },
    toggle () {
      let is_hot = !this.is_hot
      const status = this.status
      if (is_hot && status && status !== 'active') {
        this.toast(FLAME_ACTIVE_ONLY_MSG)
        return
      }
      return this.$network_utils.updatePosition({
        position_id: this.payload.id,
        current_company_id: this.payload.company.resource_id,
        is_hot: is_hot,
        active_at: new Date()
      }).then(() => {
        this.is_hot = is_hot
        this.$network_utils.postStat({
          designator: `position is ${is_hot ? 'hot' : 'cold'}`,
          title: `position is ${is_hot ? 'hot' : 'cold'}`,
          content: `${this.$utils.getOwner().name} turned ${is_hot ? 'on' : 'off'} flame`,
          priority: 6,
          resource_type: 'Position',
          resource_id: this.payload.id,
          owner: this.$utils.getOwner().name
        })
        if (this.is_hot) {
          this.openTurnOnFlame()
          return
        }
        this.expireOutsourcePosition()
      }).catch(error => {
        this.is_hot = !is_hot
        this.toast(this.errorMessage(error))
      })
    },
    openTurnOnFlame () {
      this.create({
        designator: 'turn-on-flame-modal',
        component_name: 'ModalTurnOnFlame',
        data: this.payload,
        modal_title: 'Turn on flame'
      })
    },
    expireOutsourcePosition () {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        show_confirmation_text: false,
        prompt_title: `הסרת את הלהבה.<br>האם ברצונך (בנוסף) לשנות את סטטוס המשרה ל- expired?`,
        modal_title: 'Expire ' + this.payload.title + '?',
        item_name: this.payload.title,
        method: 'updateOutsourcePosition',
        method_params: { env_position_id: this.payload.id, status: 'expired', env: this.$settings.get({ path: 'operation_name' }) }
      })
    },
    getSelectedImage () {
      return this.is_hot == true ? '/fire_red.svg' : '/fire_black.svg'
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
<style scoped>
  .is_hot{
    min-width: 30px;
    max-width: 30px;
  }
</style>
